/* eslint-disable indent */

// GSCCONTRATTO - Formula assicurata
export const gsccontratto_1_11 = {
    cod_maschera: 'GSCCONTRATTO',
    desc_maschera: 'FORMULA ASSICURATA',
    cod_paragrafo: '1',
    desc_paragrafo: 'Dati contrattuali',
    cod_campo: '11',
    desc_campo: 'Formula assicurata',
    livello: 'CONTRATTO',
    options: [
        {
            valore: '111',
            label: '1) IMMOBILE + NUCLEO FAMILIARE',
        },
        {
            valore: '112',
            label: '2) SOLO NUCLEO FAMILIARE',
        },
        {
            valore: '113',
            label: '3) SOLO IMMOBILE',
        },
    ],
};

export const gsccontratto_1_12 = {
    cod_maschera: 'GSCCONTRATTO',
    desc_maschera: 'FORMULA ASSICURATA',
    cod_paragrafo: '1',
    desc_paragrafo: 'Dati contrattuali',
    cod_campo: '12',
    desc_campo: 'Franchigia fissa 350 euro (immobile)',
    livello: 'CONTRATTO',
    options: [
        {
            valore: '12S',
            label: 'SI',
        },
        {
            valore: '12N',
            label: 'NO',
        },
    ],
};

export const gsccontratto_1_13 = {
    cod_maschera: 'GSCCONTRATTO',
    desc_maschera: 'FORMULA ASSICURATA',
    cod_paragrafo: '1',
    desc_paragrafo: 'Dati contrattuali',
    cod_campo: '13',
    desc_campo: 'Franchigia fissa 350 euro (nucleo familiare)',
    livello: 'CONTRATTO',
    options: [
        {
            valore: '13S',
            label: 'SI',
        },
        {
            valore: '13N',
            label: 'NO',
        },
    ],
};
export const garanzie_assicurato = [
    {
        tipo: 'ELEMENTARE',
        cod_pacchetto: 'null',
        desc_pacchetto: 'null',
        cod_garanzia: 'RCVP',
        show_when_formula: ['111'],
        desc_garanzia: 'RC CAPOFAMIGLIA VITA PRIVATA',
        tipo_bene: 'ASSICURATO',
        parameters: [
            {
                desc_parameter: 'Massimale',
                cod_param: 'massimale',
                options: [
                    {
                        valore: '1',
                        label: '500.000 €',
                    },
                    {
                        valore: '2',
                        label: '1.000.000 €',
                    },
                    {
                        valore: '3',
                        label: '1.500.000 €',
                    },
                    {
                        valore: '4',
                        label: '2.000.000 €',
                    },
                    // {
                    //     valore: '5',
                    //     label: '2.000.000 €',
                    // },
                ],
            },
        ],
    },
    {
        tipo: 'ELEMENTARE',
        cod_pacchetto: 'null',
        desc_pacchetto: 'null',
        cod_garanzia: 'RCVC',
        show_when_formula: ['112'],
        desc_garanzia: 'RC CAPOFAMIGLIA VITA PRIVATA E CONDUZIONE',
        tipo_bene: 'ASSICURATO',
        parameters: [
            {
                desc_parameter: 'Massimale',
                cod_param: 'massimale',
                options: [
                    {
                        valore: '1',
                        label: '500.000 €',
                    },
                    {
                        valore: '2',
                        label: '1.000.000 €',
                    },
                    {
                        valore: '3',
                        label: '1.500.000 €',
                    },
                    {
                        valore: '4',
                        label: '2.000.000 €',
                    },
                    // {
                    //     valore: '5',
                    //     label: '2.000.000 €',
                    // },
                ],
            },
        ],
    },
    {
        tipo: 'ELEMENTARE',
        cod_pacchetto: 'null',
        desc_pacchetto: 'null',
        cod_garanzia: 'RCAD',
        show_when_formula: ['111', '112'],
        desc_garanzia: 'RC CAPOFAMIGLIA ESTENSIONE ANIMALI',
        tipo_bene: 'ASSICURATO',
        parameters: [],
    },
    {
        tipo: 'ELEMENTARE',
        cod_pacchetto: 'null',
        desc_pacchetto: 'null',
        cod_garanzia: 'RCO',
        show_when_formula: ['111', '112'],
        desc_garanzia: 'RC VERSO PRESTATORI DI LAVORO',
        tipo_bene: 'ASSICURATO',
        parameters: [
            {
                desc_parameter: 'Massimale',
                cod_param: 'massimale',
                options: [
                    {
                        valore: '1',
                        label: '500.000 €',
                    },
                    {
                        valore: '4',
                        label: '1.000.000 €',
                    },
                    {
                        valore: '5',
                        label: '1.500.000 €',
                    },
                    // {
                    //     valore: '6',
                    //     label: '2.000.000 €',
                    // },
                ],
            },
        ],
    },
    {
        tipo: 'ELEMENTARE',
        cod_pacchetto: 'null',
        desc_pacchetto: 'null',
        cod_garanzia: 'TLVP',
        show_when_formula: ['111'],
        desc_garanzia: 'TUTELA LEGALE VITA PRIVATA',
        tipo_bene: 'ASSICURATO',
        parameters: [],
    },
    {
        tipo: 'ELEMENTARE',
        cod_pacchetto: 'null',
        desc_pacchetto: 'null',
        cod_garanzia: 'TLVC',
        show_when_formula: ['112'],
        desc_garanzia: 'TUTELA LEGALE VITA PRIVATA E CONDUZIONE',
        tipo_bene: 'ASSICURATO',
        parameters: [],
    },
    {
        tipo: 'ELEMENTARE',
        cod_pacchetto: 'null',
        desc_pacchetto: 'null',
        cod_garanzia: 'AS1',
        show_when_formula: ['112'],
        desc_garanzia: 'ASSISTENZA',
        tipo_bene: 'ASSICURATO',
        parameters: [],
    },
];

export const garanzie_ubicazione = [
    {
        tipo: 'PACCHETTO',
        cod_pacchetto: 'INCF',
        is_fabbricato: true,
        desc_pacchetto: 'INCENDIO FABBRICATO',
        cod_garanzie: ['IF8', 'IF9'],
        desc_garanzia: 'INCENDIO FABBRICATO',
        group_garanzia: 'INCENDIO',
        tipo_bene: 'UBICAZIONE',
        parameters: [
            {
                desc_parameter: 'Forma di copertura',
                cod_param: 'forma_copertura',
                options: [
                    {
                        valore: '1',
                        label: 'Valore intero',
                    },
                    {
                        valore: '2',
                        label: 'Primo rischio assoluto',
                    },
                ],
            },
        ],
    },
    {
        tipo: 'PACCHETTO',
        cod_pacchetto: 'INCC',
        is_contenuto: true,
        desc_pacchetto: 'INCENDIO CONTENUTO',
        cod_garanzie: ['IC8', 'IC9'],
        group_garanzia: 'INCENDIO',
        desc_garanzia: 'INCENDIO CONTENUTO',
        tipo_bene: 'UBICAZIONE',
        parameters: [
            {
                desc_parameter: 'Forma di copertura',
                cod_param: 'forma_copertura',
                options: [
                    // {
                    //     valore: '1',
                    //     label: 'Valore intero',
                    // },
                    {
                        valore: '1', // ? WAS 2 now set to 1 ask for specifications
                        label: 'Primo rischio assoluto',
                    },
                ],
            },
        ],
    },
    {
        tipo: 'PACCHETTO',
        cod_pacchetto: 'FEF',
        is_fabbricato: true,
        desc_pacchetto: 'FENOMENO ELETTRICO FABBRICATO',
        cod_garanzie: ['FEF8', 'FEF9'],
        group_garanzia: 'INCENDIO',
        desc_garanzia: 'FENOMENO ELETTRICO FABBRICATO',
        tipo_bene: 'UBICAZIONE',
        parameters: [
            {
                desc_parameter: 'Massimale',
                cod_param: 'massimale',
                options: [
                    {
                        valore: '1',
                        label: '3.000 €',
                    },
                    {
                        valore: '2',
                        label: '6.000 €',
                    },
                    {
                        valore: '3',
                        label: '10.000 €',
                    },
                    {
                        valore: '4',
                        label: '15.000 €',
                    },
                ],
            },
        ],
    },
    {
        tipo: 'PACCHETTO',
        cod_pacchetto: 'FEC',
        desc_pacchetto: 'FENOMENO ELETTRICO CONTENUTO',
        cod_garanzie: ['FEC8', 'FEC9'],
        is_contenuto: true,
        group_garanzia: 'INCENDIO',
        desc_garanzia: 'FENOMENO ELETTRICO CONTENUTO',
        tipo_bene: 'UBICAZIONE',
        parameters: [
            {
                desc_parameter: 'Massimale',
                cod_param: 'massimale',
                options: [
                    {
                        valore: '1',
                        label: '3.000 €',
                    },
                    {
                        valore: '2',
                        label: '6.000 €',
                    },
                    {
                        valore: '3',
                        label: '10.000 €',
                    },
                    {
                        valore: '4',
                        label: '15.000 €',
                    },
                ],
            },
        ],
    },
    {
        tipo: 'PACCHETTO',
        cod_pacchetto: 'EAF',
        is_fabbricato: true,
        desc_pacchetto: 'EVENTI ATMOSFERICI FABBRICATO',
        cod_garanzie: ['EAF8C', 'EAF9', 'EAF9C'],
        group_garanzia: 'INCENDIO',
        desc_garanzia: 'EVENTI ATMOSFERICI FABBRICATO',
        tipo_bene: 'UBICAZIONE',
        parameters: [],
    },
    {
        tipo: 'ELEMENTARE',
        cod_pacchetto: 'SPF',
        desc_pacchetto: 'null',
        is_fabbricato: true,
        cod_garanzie: ['SPF'],
        group_garanzia: 'INCENDIO',
        desc_garanzia: "SPARGIMENTO D'ACQUA FABBRICATO",
        tipo_bene: 'UBICAZIONE',
        parameters: [],
    },
    {
        tipo: 'PACCHETTO',
        cod_pacchetto: 'EAC',
        desc_pacchetto: 'EVENTI ATMOSFERICI CONTENUTO',
        cod_garanzie: ['EAC8C', 'EAC9', 'EAC9C'],
        group_garanzia: 'INCENDIO',
        is_contenuto: true,
        desc_garanzia: 'EVENTI ATMOSFERICI CONTENUTO',
        tipo_bene: 'UBICAZIONE',
        parameters: [],
    },
    {
        tipo: 'ELEMENTARE',
        cod_pacchetto: 'SPC',
        desc_pacchetto: 'null',
        cod_garanzie: ['SPC'],
        is_contenuto: true,
        group_garanzia: 'INCENDIO',
        desc_garanzia: "SPARGIMENTO D'ACQUA CONTENUTO",
        tipo_bene: 'UBICAZIONE',
        parameters: [],
    },
    {
        tipo: 'PACCHETTO',
        cod_pacchetto: 'ESF',
        desc_pacchetto: 'EVENTI SOCIOPOLITICI FABBRICATO',
        cod_garanzie: ['ESF8', 'ESF9'],
        is_fabbricato: true,
        group_garanzia: 'INCENDIO',
        desc_garanzia: 'EVENTI SOCIOPOLITICI FABBRICATO',
        tipo_bene: 'UBICAZIONE',
        parameters: [],
    },
    {
        tipo: 'PACCHETTO',
        cod_pacchetto: 'ESC',
        desc_pacchetto: 'EVENTI SOCIOPOLITICI CONTENUTO',
        cod_garanzie: ['ESC8', 'ESC9'],
        is_contenuto: true,
        group_garanzia: 'INCENDIO',
        desc_garanzia: 'EVENTI SOCIOPOLITICI CONTENUTO',
        tipo_bene: 'UBICAZIONE',
        parameters: [],
    },
    {
        tipo: 'PACCHETTO',
        cod_pacchetto: 'PSF',
        desc_pacchetto: 'PANNELLI SOLARI FABBRICATO',
        cod_garanzie: ['PSF8', 'PSF8C', 'PSF9'],
        group_garanzia: 'INCENDIO',
        is_fabbricato: true,
        desc_garanzia: 'PANNELLI SOLARI FABBRICATO',
        tipo_bene: 'UBICAZIONE',
        parameters: [
            {
                desc_parameter: 'Massimale',
                cod_param: 'massimale',
                options: [
                    {
                        valore: '1',
                        label: '5.000 €',
                    },
                    {
                        valore: '2',
                        label: '7.500 €',
                    },
                    {
                        valore: '3',
                        label: '12.500 €',
                    },
                    {
                        valore: '4',
                        label: '15.000 €',
                    },
                    {
                        valore: '5',
                        label: '20.000 €',
                    },
                    {
                        valore: '6',
                        label: '30.000 €',
                    },
                ],
            },
        ],
    },
    {
        tipo: 'ELEMENTARE',
        cod_pacchetto: 'RGF',
        desc_pacchetto: 'null',
        cod_garanzie: ['RGF'],
        group_garanzia: 'INCENDIO',
        is_fabbricato: true,
        desc_garanzia: 'RICERCA E RIPARAZIONE GUASTI FABBRICATO',
        tipo_bene: 'UBICAZIONE',
        parameters: [],
    },
    {
        tipo: 'ELEMENTARE',
        cod_pacchetto: 'LR',
        desc_pacchetto: 'null',
        cod_garanzie: ['LC', 'LF'],
        group_garanzia: 'LASTRE',
        is_contenuto: true,
        desc_garanzia: 'LASTRE',
        tipo_bene: 'UBICAZIONE',
        parameters: [
            {
                desc_parameter: 'Massimale',
                cod_param: 'massimale',
                options: [
                    {
                        valore: '1',
                        label: '1.500 €',
                    },
                    {
                        valore: '2',
                        label: '2.500 €',
                    },
                    {
                        valore: '3',
                        label: '4.000 €',
                    },
                ],
            },
        ],
    },
    {
        tipo: 'ELEMENTARE',
        cod_pacchetto: 'RCF',
        desc_pacchetto: 'null',
        cod_garanzie: ['RCF'],
        is_fabbricato: true,
        group_garanzia: 'RESPONSABILITÀ CIVILE',
        desc_garanzia: 'RC FABBRICATO',
        tipo_bene: 'UBICAZIONE',
        parameters: [
            {
                desc_parameter: 'Massimale',
                cod_param: 'massimale',
                options: [
                    {
                        valore: '1',
                        label: '500.000 €',
                    },
                    {
                        valore: '2',
                        label: '750.000 €',
                    },
                    {
                        valore: '3',
                        label: '1.000.000 €',
                    },
                    {
                        valore: '4',
                        label: '1.500.000 €',
                    },
                    // {
                    //     valore: '5',
                    //     label: '2.000.000 €',
                    // },
                ],
            },
        ],
    },
    {
        tipo: 'ELEMENTARE',
        cod_pacchetto: 'RCC',
        desc_pacchetto: 'null',
        cod_garanzie: ['RCC'],
        is_contenuto: true,
        group_garanzia: 'RESPONSABILITÀ CIVILE',
        desc_garanzia: 'RC CONDUZIONE',
        tipo_bene: 'UBICAZIONE',
        parameters: [
            {
                desc_parameter: 'Massimale',
                cod_param: 'massimale',
                options: [
                    {
                        valore: '1',
                        label: '500.000 €',
                    },
                    {
                        valore: '2',
                        label: '1.000.000 €',
                    },
                    {
                        valore: '3',
                        label: '1.500.000 €',
                    },
                    {
                        valore: '4',
                        label: '2.000.000 €',
                    },
                    // {
                    //     valore: '5',
                    //     label: '3.000.000 €',
                    // },
                ],
            },
        ],
    },
    {
        tipo: 'ELEMENTARE',
        cod_pacchetto: 'TF',
        desc_pacchetto: 'null',
        cod_garanzie: ['TF'],
        is_fabbricato: true,
        group_garanzia: 'CATASTROFALE',
        desc_garanzia: 'TERREMOTO DANNI AI LOCALI',
        tipo_bene: 'UBICAZIONE',
        parameters: [],
    },
    {
        tipo: 'ELEMENTARE',
        cod_pacchetto: 'TC',
        desc_pacchetto: 'null',
        cod_garanzie: ['TC'],
        is_fabbricato: true,
        group_garanzia: 'CATASTROFALE',
        desc_garanzia: 'TERREMOTO DANNI AL CONTENUTO',
        tipo_bene: 'UBICAZIONE',
        parameters: [],
    },
    {
        tipo: 'ELEMENTARE',
        cod_pacchetto: 'AF',
        desc_pacchetto: 'null',
        cod_garanzie: ['AF'],
        is_fabbricato: true,
        group_garanzia: 'CATASTROFALE',
        desc_garanzia: 'ALLUVIONE, INONDAZIONE, FLASH FLOOD DANNI AI LOCALI',
        tipo_bene: 'UBICAZIONE',
        parameters: [],
    },
    {
        tipo: 'ELEMENTARE',
        cod_pacchetto: 'AC',
        desc_pacchetto: 'null',
        cod_garanzie: ['AC'],
        is_fabbricato: true,
        group_garanzia: 'CATASTROFALE',
        desc_garanzia: 'ALLUVIONE, INONDAZIONE, FLASH FLOOD DANNI AL CONTENUTO',
        tipo_bene: 'UBICAZIONE',
        parameters: [],
    },
    {
        tipo: 'ELEMENTARE',
        cod_pacchetto: 'FU',
        desc_pacchetto: 'null',
        cod_garanzie: ['FU'],
        group_garanzia: 'FURTO',
        desc_garanzia: 'FURTO CONTENUTO',
        tipo_bene: 'UBICAZIONE',
        parameters: [
            {
                desc_parameter: 'Massimale',
                cod_param: 'massimale',
                options: [
                    {
                        valore: '1',
                        label: '5.000 €',
                    },
                    {
                        valore: '2',
                        label: '10.000 €',
                    },
                    {
                        valore: '3',
                        label: '20.000 €',
                    },
                    {
                        valore: '4',
                        label: '30.000 €',
                    },
                    {
                        valore: '5',
                        label: '40.000 €',
                    },
                    {
                        valore: '6',
                        label: '50.000 €',
                    },
                    {
                        valore: '7',
                        label: '75.000 €',
                    },
                    {
                        valore: '8',
                        label: '100.000 €',
                    },
                    {
                        valore: '9',
                        label: '200.000 €',
                    },
                ],
            },
            {
                desc_parameter: 'Antifurto per esterno',
                cod_param: 'antifurto_esterno',
                options: [
                    {
                        valore: '1',
                        label: 'Si, con centrale operativa',
                    },
                    {
                        valore: '2',
                        label: 'Si, senza centrale operativa',
                    },
                    {
                        valore: '3',
                        label: 'No',
                    },
                ],
            },
            {
                desc_parameter: 'Estensione sottolimite oggetti pregiati',
                cod_param: 'estensione_sottolimite_pregiati',
                options: [
                    {
                        valore: '1',
                        label: 'Nessun incremento',
                    },
                    {
                        valore: '2',
                        label: '10.000 €',
                    },
                    {
                        valore: '3',
                        label: '20.000 €',
                    },
                    {
                        valore: '4',
                        label: '30.000 €',
                    },
                    {
                        valore: '5',
                        label: '40.000 €',
                    },
                ],
            },
            {
                desc_parameter: 'Estensione sottolimite gioielli preziosi',
                cod_param: 'estensione_sottolimite_gioielli',
                options: [
                    {
                        valore: '1',
                        label: 'Nessun incremento',
                    },
                    {
                        valore: '2',
                        label: '10.000 €',
                    },
                    {
                        valore: '3',
                        label: '20.000 €',
                    },
                    {
                        valore: '4',
                        label: '30.000 €',
                    },
                    {
                        valore: '5',
                        label: '40.000 €',
                    },
                ],
            },
            {
                desc_parameter: 'Valori e Denaro contante',
                cod_param: 'valori_denaro',
                options: [
                    {
                        valore: '1',
                        label: 'Si',
                    },
                    {
                        valore: '2',
                        label: 'No',
                    },
                ],
            },
            {
                desc_parameter: 'Scippo e rapina',
                cod_param: 'scippo_rapina',
                options: [
                    {
                        valore: '1',
                        label: 'Si',
                    },
                    {
                        valore: '2',
                        label: 'No',
                    },
                ],
            },
        ],
    },
    {
        tipo: 'ELEMENTARE',
        cod_pacchetto: 'TLPC',
        desc_pacchetto: 'null',
        cod_garanzie: ['TLPC'],
        group_garanzia: 'TUTELA LEGALE',
        desc_garanzia: 'TUTELA LEGALE PROPRIETÀ E CONDUZIONE',
        tipo_bene: 'UBICAZIONE',
        parameters: [],
    },
    {
        tipo: 'ELEMENTARE',
        cod_pacchetto: 'AS2',
        desc_pacchetto: 'null',
        cod_garanzie: ['AS2'],
        group_garanzia: 'ASSISTENZA',
        desc_garanzia: 'ASSISTENZA',
        tipo_bene: 'UBICAZIONE',
        parameters: [],
    },
    // {
    //     tipo: 'PACCHETTO',
    //     cod_pacchetto: 'LS',
    //     desc_pacchetto: 'LIFE STYLE',
    //     cod_garanzie: ['ITT1', 'ITT2', 'PI', 'RO1', 'RO2', 'ITP1', 'ITP2'],
    //     group_garanzia: 'LIFE STYLE',
    //     desc_garanzia: 'LIFE STYLE',
    //     tipo_bene: 'UBICAZIONE',
    //     parameters: [
    //         {
    //             desc_parameter: 'Massimale',
    //             cod_param: 'massimale',
    //             options: [
    //                 {
    //                     valore: '1',
    //                     label: '1.300 €',
    //                 },
    //                 {
    //                     valore: '2',
    //                     label: '2.500 €',
    //                 },
    //                 {
    //                     valore: '3',
    //                     label: '5.000 €',
    //                 },
    //                 {
    //                     valore: '4',
    //                     label: '10.000 €',
    //                 },
    //             ],
    //         },
    //     ],
    // },
];

export const calculateAge = (dateOfBirth) => {
    const dob = new Date(dateOfBirth);
    const today = new Date();

    let age = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();
    const dayDiff = today.getDate() - dob.getDate();

    // Adjust the age if the birthday hasn't occurred yet this year
    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
        age--;
    }

    return age;
};
